import './exportable_report_view.js.coffee'
Namespace 'Customer.Views.Insights'

class Customer.Views.Insights.ActivityReportView extends Customer.Views.Insights.ExportableReportView
  jobURL: 'activity/report_job'
  infoURL: 'activity/info_before_execution'
  events:
    'click #filter': '_startActivityReportJob'
    'click #activity-export-excel': '_startActivityReportExcelJob'
    'click #export-confirm': 'exportConfirm'

  _startActivityReportJob: (event) ->
    event.preventDefault()
    @selectAllRightSideGroups()
    @selectAllChosedTags()
    @selectAllChosedCustomAttributes()
    @showLoadingAnimation()
    @activityReportJob(data: @serializeData(@$el)).start()

  _startActivityReportExcelJob: (event) ->
    event.preventDefault()
    @showLoadingAnimation()
    @activityReportExcelJob(data: @serializeData(@$el))

  showActivityTable: (results) =>
    @resultsView.remove() if @resultsView
    @resultsView = new Customer.Views.Insights.ActivityResultsView(
      activityType: @selectedActivityType()
      results: results
    ).render()

  _serializedIntelligentFilter: (name) ->
    data = []

    data.push({name: "main_#{name}_logic", value: $(".main_#{name} .#{name}-logic").text()})
    data.push({name: "secondary_#{name}_logic", value: $(".secondary_#{name} .#{name}-logic").text()})
    data.push({name: "excluded_#{name}_logic", value: $(".excluded_#{name} .#{name}-logic").text()})

    @$report.find(".main_#{name} .elements span.#{name}-filter-option").each((index) ->
      data.push({name: "main_#{name}[]", value: $(@).text()})
    )

    @$report.find(".secondary_#{name} .elements span.#{name}-filter-option").each((index) ->
      data.push({name: "secondary_#{name}[]", value: $(@).text()})
    )

    @$report.find(".excluded_#{name} .elements span.#{name}-filter-option").each((index) ->
      data.push({name: "excluded_#{name}[]", value: $(@).text()})
    )

    data

  _serializedTimeZoneFilter: ->
    data = [];
    selected_timezone = $('#timezone-selector select').val().replace('GMT', '')
    data.push({name: 'timezone', value: selected_timezone})
    data

  _serializedUserGroupsFilter: =>
    @_serializeUserAndGroupSelect('user_groups[]', @$('#user-and-group-selection').find('li.user-group-filter-option'))

  _serializedUsersFilter: =>
    @_serializeUserAndGroupSelect('users[]', @$('#user-and-group-selection').find('li.user-filter-option'))

  _serializeUserAndGroupSelect: (key, list) =>
    data = []
    _.each(list, (element) =>
      data.push({name: key, value: "#{element.value}"})
    )
    data

  serializeData: (scope) =>
    data = scope.serializeArray();
    Array.prototype.push.apply(data, @_serializedUserGroupsFilter())
    Array.prototype.push.apply(data, @_serializedUsersFilter())
    Array.prototype.push.apply(data, @_serializedIntelligentFilter('tags'))
    Array.prototype.push.apply(data, @_serializedIntelligentFilter('groups'))
    Array.prototype.push.apply(data, @_serializedTimeZoneFilter())
    Array.prototype.push.apply(data, @_serializedHasRobot())
    data

  _serializedHasRobot: =>
    [{ name: 'has_robot', value: @$('#has-robot').prop('checked') }]

  selectedActivityType: =>
    @$('input[name=activity_type]:checked').val()

  setUpDrillDownLinks: =>
    @drillDownView.remove() if @drillDownView
    @drillDownView = new Customer.Views.Insights.ActivityDrillDownView @serializeData(@$el)

  selectAllRightSideGroups: ->
    @$('#groupsRightValues').find('option').prop('selected', 'selected')

  selectAllChosedTags: ->
    @$('#tagsValues').find('option').prop('selected', 'selected')

  selectAllChosedCustomAttributes: ->
    selectedOptions = []
    _.each(@$('#custom-attributes-filter-selectors').children(), (customAttributeFilter) ->
      attributeName = $(customAttributeFilter).find('[name^="ca_"]')[0].name
      _.each($(customAttributeFilter).find('[disabled]'), (selectedOption) ->
        selectedOptions.push "#{attributeName}#{$(selectedOption).text()}"
      )
      _.each($($('#custom-attributes-filter-selectors').children()).find('h2').siblings('select'), (filterSelect) ->
        attributeName = filterSelect.name
        _.each($(filterSelect).find('option'), (filterOption) ->
          if _.contains(selectedOptions, "#{attributeName}#{$(filterOption).text()}")
            $(filterOption).prop('selected', 'selected')
          else
            $(filterOption).prop('selected', false)
        )
      )
    )
